import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import * as Yup from "yup";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import apiClient from "../../../../services/axios_api";

const AddEditGateKeeper = ({
  onHide,
  editable,
  setRes,
  setDialog,
  rowData,
}) => {
  const [loading, setLoading] = useState(false);
  const [gateList, setGateList] = useState();

  const validationSchema = Yup.object({
    phoneNumber: Yup.string()
      .required("Mobile number is required")
      .matches(/^[3-9]\d{9}$/, "Invalid mobile number"),
    name: Yup.string()
      .required("Name is required")
      .max(30, "Name must be 30 characters"),
    pin: editable
      ? Yup.string().notRequired()
      : Yup.string()
          .required("Pin is required")
          .min(4, "Pin must be at least 4 characters")
          .max(30, "Pin must be at most 30 characters"),

    cnicNumber: Yup.string()
      .required("CNIC is required")
      .min(13, "CNIC must be 13 characters")
      .max(13, "CNIC must be 13 characters"),
    gateId: Yup.string().required("Gate number is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      phoneNumber: "",
      name: "",
      pin: "",
      newPin: "",
      address: "",
      cnicNumber: "",
      gateId: "",
      email: "",
    },

    onSubmit: async (data) => {
      setLoading(true);
      try {
        data.phoneNumber = `+92${data.phoneNumber}`;
        const payload = editable ? { ...data, id: rowData.id } : { ...data };

        const response = editable
          ? await apiClient.put("/TellerUser/update", payload)
          : await apiClient.post("/TellerUser/add", payload);

        setRes(response.data);
        toast.success(
          editable
            ? "Gate Keeper Updated Successfully"
            : "Gate Keeper Added Successfully"
        );
        setDialog(false);
      } catch (error) {
        const errorMessage =
          error.response?.data?.responseDescription ||
          "Operation failed, please try again";

        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
  });

  const GetGates = async (rowData) => {
    const userId = JSON.parse(localStorage.getItem("user"))?.id;
    try {
      const response = await apiClient.post("/Gates/list", {
        loggedInUserId: userId,
      });
      setGateList(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (editable && rowData) {
      formik.setFieldValue("name", rowData?.name);
      formik.setFieldValue(
        "phoneNumber",
        rowData?.phoneNumber?.replace(/^\+92/, "")
      );
      formik.setFieldValue("email", rowData?.email);
      formik.setFieldValue("pin", rowData?.pin);
      formik.setFieldValue("address", rowData?.address);
      formik.setFieldValue("cnicNumber", rowData?.cnicNumber);

      if (rowData?.accessControls?.length > 0) {
        const gateNumber = rowData.accessControls[0]?.gate?.id || "";
        formik.setFieldValue("gateId", gateNumber);
      }
    }
  }, [editable, rowData]);

  useEffect(() => {
    GetGates();
  }, []);

  return (
    <>
      {" "}
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid formgrid grid">
          <div className="field  md:col-6">
            <label htmlFor="" style={{ fontWeight: "bold" }}>
              Name <span className="Staric-Custom"> *</span>
            </label>
            <InputText
              placeholder="Enter name"
              maxLength={30}
              id="name"
              name="name"
              type="text"
              value={formik.values.name}
              onChange={(e) => {
                const sanitizedValue = e.target.value.replace(
                  /[^a-zA-Z\s]/g,
                  ""
                );
                formik.setFieldValue("name", sanitizedValue);
              }}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className="error">{formik.errors.name}</div>
            ) : null}
          </div>
          <div className="field  md:col-6">
            <label htmlFor="" style={{ fontWeight: "bold" }}>
              Mobile Number <span className="Staric-Custom"> *</span>
            </label>
            <div className="p-inputgroup">
              <span className="p-inputgroup-addon">+92</span>
              <InputText
                placeholder="Enter mobile number"
                id="phoneNumber"
                name="phoneNumber"
                type="text"
                maxLength={10}
                value={formik.values.phoneNumber}
                onChange={(e) => {
                  let input = e.target.value.replace(/[^\d]/g, "");
                  if (input.startsWith("0")) {
                    input = input.substring(1);
                  }
                  formik.setFieldValue("phoneNumber", input);
                }}
              />
            </div>

            {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
              <div className="error">{formik.errors.phoneNumber}</div>
            ) : null}
          </div>
          {editable ? null : (
            <div className="field  md:col-6 password-icon">
              <label htmlFor="" style={{ fontWeight: "bold" }}>
                Pin <span className="Staric-Custom"> *</span>
              </label>
              <Password
                placeholder="Enter pin"
                maxLength={4}
                id="pin"
                name="pin"
                type="text"
                value={formik.values.pin}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("pin", sanitizedValue);
                }}
                toggleMask
                feedback={false}
              />
              {formik.touched.pin && formik.errors.pin ? (
                <div className="error">{formik.errors.pin}</div>
              ) : null}
            </div>
          )}
          {editable ? (
            <div className="field  md:col-6 password-icon">
              <label htmlFor="" style={{ fontWeight: "bold" }}>
                New Pin <span className="Staric-Custom"> *</span>
              </label>
              <Password
                placeholder="Enter new pin"
                maxLength={4}
                id="newPin"
                name="newPin"
                type="text"
                value={formik.values.newPin}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("newPin", sanitizedValue);
                }}
                toggleMask
                feedback={false}
              />
              {formik.touched.newPin && formik.errors.newPin ? (
                <div className="error">{formik.errors.newPin}</div>
              ) : null}
            </div>
          ) : null}

          <div className="field  md:col-6">
            <label className="mb-2" style={{ fontWeight: "bold" }}>
              Gate Number<span style={{ color: "red" }}>*</span>
            </label>
            <Dropdown
              value={formik.values.gateId}
              optionLabel="number"
              name="gateId"
              filter
              options={gateList || []}
              emptyMessage="No options available"
              optionValue="id"
              placeholder="Select Gate"
              // onChange={formik.handleChange}
              onChange={(e) => formik.setFieldValue("gateId", e.value)}
            />
            {formik.touched.gateId && formik.errors.gateId ? (
              <div className="error">{formik.errors.gateId}</div>
            ) : null}
          </div>
          <div className="field  md:col-6">
            <label htmlFor="" style={{ fontWeight: "bold" }}>
              CNIC <span className="Staric-Custom"> *</span>
            </label>
            <InputText
              placeholder="Enter CNIC number"
              id="cnicNumber"
              name="cnicNumber"
              type="text"
              value={formik.values.cnicNumber}
              maxLength={13}
              onChange={(e) =>
                formik.setFieldValue(
                  "cnicNumber",
                  e.target.value.replace(/[^0-9]/g, "")
                )
              }
            />
            {formik.touched.cnicNumber && formik.errors.cnicNumber ? (
              <div className="error">{formik.errors.cnicNumber}</div>
            ) : null}
          </div>
          <div className="field  md:col-6">
            <label htmlFor="" style={{ fontWeight: "bold" }}>
              Email <span className="Staric-Custom"> *</span>
            </label>
            <InputText
              placeholder="Enter Email"
              id="email"
              name="email"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="error">{formik.errors.email}</div>
            ) : null}
          </div>
          <div className="field  md:col-6">
            <label htmlFor="" style={{ fontWeight: "bold" }}>
              Address{" "}
            </label>
            <InputText
              placeholder="Enter address"
              id="address"
              maxLength={99}
              name="address"
              type="text"
              value={formik.values.address}
              onChange={formik.handleChange}
            />
          </div>

          <div className="buttons-container">
            <div className="button-group">
              <Button
                className="custom-white"
                label="Cancel"
                type="button"
                onClick={onHide}
              />
            </div>

            <div className="button-group">
              <Button
                loading={loading}
                className="custom-btn"
                label={editable ? "Update" : "Add "}
                type="submit"
                disabled={loading}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddEditGateKeeper;
